export default __webpack_public_path__ + "static/media/warning--equestrians-crossing--g1.19b9300d.png";